"use client";

import * as React from "react";
import { Building2, Menu, X, LogOut } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Outlet, useNavigate, useLocation } from "react-router-dom";
import { clearStoredAuth } from "../utils/authStorage";

export function SuperSchooladminSidebar() {
  const navigate = useNavigate();
  const location = useLocation();
  const currentTab = location.pathname.split("/")[2] || "schools";
  const [isSidebarOpen, setIsSidebarOpen] = React.useState(true);

  const menuItems = [
    {
      id: "schools",
      label: "My Schools",
      icon: <Building2 className="w-5 h-5" />,
      path: "/dashboard/schools",
    },
  ];

  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };

  return (
    <div className="flex h-full bg-gray-50 relative overflow-hidden">
      <Button
        variant="ghost"
        className="lg:hidden fixed top-4 left-4 z-50 p-2"
        onClick={toggleSidebar}
      >
        {isSidebarOpen ? (
          <X className="w-6 h-6" />
        ) : (
          <Menu className="w-6 h-6" />
        )}
      </Button>

      {isSidebarOpen && (
        <div
          className="fixed inset-0 bg-black/50 lg:hidden z-30"
          onClick={() => setIsSidebarOpen(false)}
        />
      )}

      <aside
        className={`
          fixed lg:static
          top-0 bottom-0 left-0
          w-[280px] lg:w-72
          bg-white border-r border-gray-200
          transform transition-transform duration-300 ease-in-out
          ${
            isSidebarOpen
              ? "translate-x-0"
              : "-translate-x-full lg:translate-x-0"
          }
          z-40
          flex flex-col
        `}
        style={{ height: '100vh' }}
      >
        <div className="flex-shrink-0 p-6 border-b border-gray-200">
          <h1 className="text-xl font-bold text-blue-700">
            Super Customer Admin
          </h1>
        </div>

        <nav
          className="flex-1 overflow-y-auto overflow-x-hidden p-4"
          style={{
            maxHeight: 'calc(100vh - 180px)',
            minHeight: 0
          }}
        >
          <div className="space-y-1">
            {menuItems.map((item) => (
              <Button
                key={item.id}
                variant={currentTab === item.id ? "secondary" : "ghost"}
                className={`w-full justify-start text-sm mb-1 min-h-[44px] ${
                  currentTab === item.id
                    ? "bg-[#0263cc] text-white"
                    : "text-gray-600 hover:text-white hover:bg-[#0263cc]"
                }`}
                onClick={() => {
                  navigate(item.path);
                  if (window.innerWidth < 1024) {
                    setIsSidebarOpen(false);
                  }
                }}
              >
                {item.icon}
                <span className="ml-3 whitespace-nowrap">{item.label}</span>
              </Button>
            ))}
          </div>
        </nav>

        <div
          className="flex-shrink-0 p-4 border-t border-gray-200 bg-white"
          style={{ marginTop: 'auto' }}
        >
          <Button
            variant="ghost"
            className="w-full justify-start text-red-600 hover:text-red-700 hover:bg-red-50 min-h-[44px]"
            onClick={() => {
              clearStoredAuth();
              window.location.href = "/login";
            }}
          >
            <LogOut className="w-5 h-5" />
            <span className="ml-3">Logout</span>
          </Button>
        </div>
      </aside>

      <main className="flex-1 overflow-auto lg:ml-0 w-full">
        <div className="p-4 sm:p-6 lg:p-8 pt-16 lg:pt-8">
          <Outlet />
        </div>
      </main>
    </div>
  );
}
